import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../../components/layout/MainLayout";
import MessageScreen from "../../components/layout/MessageScreen";
import ChatDisplay from "../../components/response/ChatDisplay";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models, powerbi } from "powerbi-client";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "../../app/auth/Login";
import { Fab, IconButton, Drawer, Button, TextField, Dialog, DialogContent } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import { useSocket } from "../../hooks/useSocket";
import PopupHome from "../Home/PopupHome";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));




const Dashboard = () => {

  const [powerbiReport,setPowerbiReport] = useState({})
  const [loading,setLoading] = useState(true)
  const [powerbiLoading,setpowerbiLoading] = useState(true)
  const [isAiPanelOpen, setIsAiPanelOpen] = useState(false)
  const [userInput, setUserInput] = useState("")
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [sidebarWidth, setSidebarWidth] = useState(400)
  const [isResizing, setIsResizing] = useState(false)
  
  // Chat states
  const [isLoading, setIsLoading] = useState(false)
  const [responceData, setResponceData] = useState([])
  const [errorData, setErrorData] = useState(false)
  const [query, setQuery] = useState("")
  const [faqScreen, setFaqScreen] = useState(true)
  const [cancelTokenSource, setCancelTokenSource] = useState(null)
  const inputRef = useRef(null)
  const [powerbiError, setPowerbiError] = useState(null);

  const { displayedLogs, emit, clearLogs } = useSocket((message) => {
    let cleanMessage = message;
    try {
      const parsed = JSON.parse(message);
      cleanMessage = typeof parsed === "string" ? parsed : parsed.message || message;
    } catch {
      cleanMessage = message;
    }
  });

  const displayedLogsRef = useRef(displayedLogs);
  useEffect(() => {
    displayedLogsRef.current = displayedLogs;
  }, [displayedLogs]);

  const baseurl = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/ask`;

  const powerbiReportData = async () =>{
    try {
      const baseurl = `https://aays-cfo-dev-be-py.azurewebsites.net/cfo/report?reportId=129`
      
      // const baseurl = `https://google.com/1`

      const response = await axios.get(baseurl);
      
      // Handling the response
      if (response.status === 200) {
        console.log('token generated successfully:', response.data);
        setLoading(false)
        setPowerbiReport(response.data)
        return response.data;
      } else {
        console.error('Error posting FAQ data:', response.status, response.statusText);
        setLoading(false)

      }
    } catch (error) {
      console.error('Error posting FAQ data:', error);
      setLoading(false)
      setpowerbiLoading(false);

      if (error.response?.status === 403) {
        setPowerbiError(error?.response?.data?.error?.error?.message || "You do not have access to this report.");
      } else {
        setPowerbiError("Something went wrong while loading the report.");
      }

    }
  }

  useEffect(()=>{
    powerbiReportData()
  },[])

const embdData = (embeddedReport) => {
  window.report = embeddedReport;
  window.report.on("loaded", async function () {
    var reportPages = await window.report.getPages();


  })

}


const token = powerbiReport.embedToken
const url = powerbiReport.reportURL
const reportGId = powerbiReport.reportGuid

const handleAiPanelToggle = () => {
  setIsAiPanelOpen(!isAiPanelOpen);
};

const handleExternalTextClick = (text) => {
  setUserInput(text);
  inputRef.current?.focus();
};

const handleSendClick = async () => {
  if (!userInput.trim()) return;

  clearLogs();
  setResponceData((prev) => prev.filter((item) => !item.log));

  setErrorData(false);
  setIsLoading(true);
  setFaqScreen(false);
  setQuery(userInput);

  setResponceData((prev) => [
    ...prev,
    { query: userInput, user: true, loading: true },
  ]);

  const source = axios.CancelToken.source();
  setCancelTokenSource(source);

  emit("start-logs", { query: userInput });

  try {
    const response = await axios.post(
      baseurl,
      { query: userInput },
      {
        cancelToken: source.token,
      }
    );

    if (response.status === 200) {
      
      const responsePayload = response.data.response || response.data;
      
      const newResponseData = { 
        ...responsePayload, 
        user: false, 
        logs: [...displayedLogsRef.current] 
      };
      
      setResponceData((prev) => {
        const updated = [...prev, newResponseData];
        return updated;
      });
      emit("askResponse", { response: responsePayload });
    } else {
      throw new Error("Bad response");
    }
  } catch (err) {
    if (!axios.isCancel(err)) {
      setErrorData(true);
      setResponceData((prev) => [...prev, { error: true, user: false }]);
      emit("askError", { error: err.message });
    }
  } finally {
    setIsLoading(false);
    setCancelTokenSource(null);
    setUserInput("");
  }
};

const handleCancelClick = () => {
  cancelTokenSource?.cancel("Request canceled by the user");
  setCancelTokenSource(null);
};

const handleDialogToggle = () => {
  if (!isDialogOpen) {
    // Opening dialog, close sidebar
    setIsDialogOpen(true);
    setIsAiPanelOpen(false);
  } else {
    // Closing dialog, reopen sidebar
    setIsDialogOpen(false);
    setIsAiPanelOpen(true);
  }
};

const newChatStart = () => {
  handleCancelClick();
  clearLogs();
  setResponceData([]);
  setFaqScreen(true);
  setUserInput("");
  setIsLoading(false);
};

const handleFormSubmit = (e) => {
  e.preventDefault();
  if (!isLoading) {
    handleSendClick();
  }
};

const handleKeyPress = (e) => {
  if (e.key === "Enter" && !isLoading) {
    handleFormSubmit(e);
  }
};

const handleMouseDown = (e) => {
  setIsResizing(true);
  e.preventDefault();
};

const handleMouseMove = (e) => {
  if (!isResizing) return;
  
  const newWidth = window.innerWidth - e.clientX;
  setSidebarWidth(newWidth);
};

const handleMouseUp = () => {
  setIsResizing(false);
};

useEffect(() => {
  if (isResizing) {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  } else {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }
  
  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
}, [isResizing]);


  return (
    <>
    
    <AuthenticatedTemplate>
      <div id="homePage">
        <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
          <MainLayout />

          {/* Overlay during resize to prevent interaction with PowerBI */}
          {isResizing && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                cursor: "ew-resize",
                backgroundColor: "transparent",
              }}
            />
          )}

          <Box 
            component="main" 
            sx={{ 
              flexGrow: 1, 
              p: 1,
              width: isAiPanelOpen ? `calc(100% - ${sidebarWidth}px)` : "100%",
              maxWidth: isAiPanelOpen ? `calc(100% - ${sidebarWidth}px)` : "100%"
            }}
          >
            <DrawerHeader />

            <div id="" className={`${powerbiLoading ? '' : 'bg-[#1d64ac]/10'} p-6 rounded mt-2`}>
              <div
                style={{
                  gridGap: "10px",
                  justifyContent: "flex-start",
                  width: "100%",
                  textAlign: "left",
                  height: "calc(100vh - 120px)",
                  position:"relative",
                  overflow: "hidden",
                  overflowY: powerbiLoading ? "none" : "auto",

                }}
              >
                <div style={{height:"100%"}}>

                  {powerbiLoading && (
                    <div style={{position:"absolute",background:"white",height:"100%",left:'0',right:"0",top:"0",bottom:'0',overflow:"hidden"}}>
                      <div style={{display:"grid",justifyContent:"center",alignContent:"center",alignItems:"center",height:"100%",overflow:"hidden",gap:"1rem"}}>
                      <div id="typingid">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>

                        <span>Please wait...</span>
                        </div>
                    </div>
                  )}

                  {!loading && !powerbiError &&(
                    <>
                      <PowerBIEmbed
                    embedConfig = {{
                      type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                      id: reportGId,
                      embedUrl: url,
                      accessToken: token,
                      tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                      settings: {
                        panes: {
                          filters: {
                            expanded: false,
                            visible: false
                          }
                        },
                        background: models.BackgroundType.Transparent,
                      }
                    }}

                      eventHandlers = {
                        new Map([
                          ['loaded', function () {
                            console.log('Report loaded');
                            setpowerbiLoading(false)
                          }],
                          ['rendered', function () {console.log('Report rendered');}],
                          ['error', function (event) {console.log(event.detail);}],
                          ['visualClicked', () => console.log('visual clicked')],
                          ['pageChanged', (event) => console.log(event)],
                        ])
                      }

                      cssClassName={"report-style-class"}
                      getEmbeddedComponent={embdData}
      
                          />
                    </>
                  )}

                  {powerbiError && (
                    <Box
                      sx={{
                        height: "100%",
                        display: "grid",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#fff",
                        borderRadius: 2,
                        color: "#d32f2f",
                        fontWeight: 600,
                        width: "100%",
                        alignContent:"center",
                        textAlign:"center",
                        gap:4
                      }}
                    >
                      <span style={{width:"60%",textAlign:"center",margin:"auto",display:"block"}}>
                      {powerbiError}
                      </span>

                      <span className="mt-2">    
                        <Button   onClick={() => window.location.reload()}
                  className="submit_btn">Refresh</Button>
                      </span>

                    </Box>
                  )}

{/* <iframe title="Promotion Analysis Dashboard"  src="https://app.powerbi.com/reportEmbed?reportId=ab980284-2bc5-4c40-b15c-871bf676e908&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454" frameborder="0" allowFullScreen="true"></iframe> */}


                </div>
              </div>
            </div>
          </Box>

          {/* Floating Ask AI Button */}
          {!isAiPanelOpen && !powerbiLoading && !powerbiError && (
            <Fab
              color="primary"
              aria-label="ask-ai"
              onClick={handleAiPanelToggle}
              variant="extended"
              sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                background: "linear-gradient(135deg, #1d64ac 0%, #37a5c6 100%)",
                "&:hover": {
                  background: "linear-gradient(135deg, #155080 0%, #2a8aa0 100%)",
                },
                height: 56,
                paddingX: 3,
                boxShadow: "0 4px 12px rgba(29, 100, 172, 0.4)",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                gap: 1,
              }}
            >
              <SmartToyIcon sx={{ fontSize: 18 }} />
              <span className="text-[16px]">Ask Aadi</span>
              <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />
            </Fab>
         )} 

          {/* AI Assistant Sidebar */}
          <Drawer
            anchor="right"
            open={isAiPanelOpen}
            onClose={handleAiPanelToggle}
            variant="persistent"
            sx={{
              width: isAiPanelOpen ? sidebarWidth : 0,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: sidebarWidth,
                boxSizing: "border-box",
                background: "#ffffff",
                borderLeft: "none",
                boxShadow: "-4px 0 12px rgba(0, 0, 0, 0.1)",
                top: "78px",
                height: "calc(100vh - 78px)",
              },
            }}
          >
            {/* Resize Handle */}
            <Box
              onMouseDown={handleMouseDown}
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "5px",
                cursor: "ew-resize",
                background: "transparent",
                zIndex: 1000,
                "&:hover": {
                  background: "rgba(29, 100, 172, 0.3)",
                },
                "&:active": {
                  background: "rgba(29, 100, 172, 0.5)",
                },
              }}
            />
            
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1,
                  borderBottom: "1px solid #e0e0e0",
                  background: "rgba(29, 100, 172, 0.1)",
                  // background: "linear-gradient(135deg, #1d64ac 0%, #37a5c6 100%)",
                  color: "white",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <SmartToyIcon sx={{ fontSize: 24, color:"#1d64ac" }} />
                  <span style={{ fontSize: "18px", fontWeight: 600, color:"#1d64ac" }}>Ask Aadi</span>
                </Box>
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {/* <IconButton
                    onClick={handleDialogToggle}
                    sx={{ color: "white" }}
                  >
                    <OpenInFullIcon />
                  </IconButton> */}
                  <IconButton
                    onClick={handleAiPanelToggle}
                    sx={{ color: "#1d64ac" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* MessageScreen Content */}
              <Box sx={{ flexGrow: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {/* Chat Display Area */}
                    <PopupHome/>
              </Box>
            </Box>
          </Drawer>

          {/* Dialog for Expanded View */}
          <Dialog
            open={isDialogOpen}
            onClose={handleDialogToggle}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                height: "80vh",
                maxHeight: "80vh",
              },
            }}
          >
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              {/* Dialog Header */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  borderBottom: "1px solid #e0e0e0",
                  background: "linear-gradient(135deg, #1d64ac 0%, #37a5c6 100%)",
                  color: "white",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <SmartToyIcon sx={{ fontSize: 28 }} />
                  <span style={{ fontSize: "20px", fontWeight: 600 }}>Ask Aadi</span>
                </Box>
                <IconButton
                  onClick={handleDialogToggle}
                  sx={{ color: "white" }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              {/* Dialog Content */}
              <DialogContent sx={{ flexGrow: 1, overflow: "hidden", p: 0, display: "flex", flexDirection: "column" }}>
                {/* Chat Display Area */}
                <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
                  {faqScreen && responceData.length === 0 ? (
                    <MessageScreen
                      setUserInput={setUserInput}
                      handleExternalTextClick={handleExternalTextClick}
                    />
                  ) : (
                    <ChatDisplay
                      responceData={responceData}
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      query={query}
                      errorData={errorData}
                      loadingIndex={0}
                      setResponceData={setResponceData}
                      isHistory={false}
                      page="Dashboard"
                    />
                  )}
                </Box>

                {/* Chat Input Area */}
                <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0", background: "#fff" }}>
                  {responceData.length > 0 && (
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={newChatStart}
                      sx={{ mb: 2, width: "100%" }}
                    >
                      New Chat
                    </Button>
                  )}
                  <form onSubmit={handleFormSubmit}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        ref={inputRef}
                        fullWidth
                        size="small"
                        placeholder="Ask a question..."
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        onKeyDown={handleKeyPress}
                        disabled={isLoading}
                      />
                      <IconButton
                        color="primary"
                        onClick={handleSendClick}
                        disabled={isLoading || !userInput.trim()}
                        type="submit"
                        sx={{ flexShrink: 0 }}
                      >
                        {isLoading ? (
                          <span className="spinner-border spinner-border-sm" />
                        ) : (
                          <SendIcon />
                        )}
                      </IconButton>
                    </Box>
                  </form>
                </Box>
              </DialogContent>
            </Box>
          </Dialog>
        </Box>
      </div>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
      <Login/>
    </UnauthenticatedTemplate>

    </>
  );
};

export default Dashboard;